import React from "react";
import MainInput from "components/MainApp/atoms/Forms/MainInput";
import MainDropdownInput from "components/MainApp/atoms/Forms/MainDropdown";

import styles from "./DescriptionForm.module.scss";
import SelectAutocomplete from "shared/components/autocomplete";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

export class DescriptionForm extends React.Component {
  render() {
    const {
      provider,
      handleChange,
      handleSelect,
      countries,
      regions,
      provinces,
      cities,
      error
    } = this.props;

    return (
      <>
        <div
          className={styles["provider-description-field"]}
          data-automation-id="input-name"
        >
          <MainInput
            label={capitalize(i18n.t("name"))}
            required={true}
            id={"provider-name"}
            name="name"
            value={provider ? provider.name : ""}
            handleChange={handleChange}
            maxLength={30}
            error={error.name && error.name}
          />
        </div>
        <div
          className={styles["provider-description-field"]}
          data-automation-id="input-business-name"
        >
          <MainInput
            label={i18n.t("company.name")}
            required={true}
            id={"provider-business-name"}
            name="business_name"
            value={provider ? provider.business_name : ""}
            handleChange={handleChange}
            maxLength={30}
            error={error.business_name && error.business_name}
          />
        </div>
        <div
          className={styles["provider-description-field"]}
          data-automation-id="input-document"
        >
          <MainInput
            label={i18n.t("document")}
            required={true}
            id={"provider-document"}
            name="document"
            value={provider ? provider.document : ""}
            handleChange={handleChange}
            maxLength={10}
            error={error.document && error.document}
          />
        </div>
        <div
          className={styles["provider-description-field"]}
          data-automation-id="input-country"
        >
          <SelectAutocomplete
            id="provider-country"
            name="country"
            label={i18n.t("country")}
            options={countries}
            placeholder={i18n.t("country")}
            selected={provider ? provider.country : {}}
            required={true}
            error={error.country && error.country}
            onChange={(id, selectedOption, target) =>
              handleSelect(selectedOption, "country")
            }
          />
        </div>
        {provider?.country?.value === "ES" && (
          <div
            className={styles["provider-description-field"]}
            data-automation-id="input-region"
          >
            <SelectAutocomplete
              id="provider-region"
              name="region"
              label={i18n.t("community")}
              options={regions}
              placeholder={i18n.t("community")}
              selected={provider ? provider.region : {}}
              required={true}
              disabled={
                !provider || !provider.country || provider.country === ""
              }
              error={error.region && error.region}
              onChange={(id, selectedOption, target) =>
                handleSelect(selectedOption, "region")
              }
            />
          </div>
        )}
        {provider?.country?.value === "ES" && (
          <div
            className={styles["provider-description-field"]}
            data-automation-id="input-state"
          >
            <SelectAutocomplete
              id="provider-state"
              name="state"
              label={i18n.t("province")}
              options={provinces}
              placeholder={i18n.t("province")}
              selected={provider ? provider.state : {}}
              disabled={!provider || !provider.region || provider.region === ""}
              required={true}
              error={error.country && error.country}
              onChange={(id, selectedOption, target) =>
                handleSelect(selectedOption, "state")
              }
            />
          </div>
        )}
        {provider?.country?.value === "ES" && (
          <div
            className={styles["provider-description-field"]}
            data-automation-id="input-locality"
          >
            <SelectAutocomplete
              id="provider-locality"
              name="locality"
              label={i18n.t("municipality")}
              options={cities}
              placeholder={i18n.t("municipality")}
              selected={provider ? provider.locality : {}}
              disabled={!provider || !provider.state || provider.state === ""}
              required={true}
              error={error.country && error.country}
              onChange={(id, selectedOption, target) =>
                handleSelect(selectedOption, "city")
              }
            />
          </div>
        )}
        <div
          className={styles["provider-description-field"]}
          data-automation-id="input-date"
        >
          <MainInput
            label={i18n.t("entry.date")}
            required={true}
            id={"provider-date"}
            name="entry_date"
            type="date"
            value={provider ? provider.entry_date : ""}
            handleChange={handleChange}
            maxLength={30}
            error={error.entry_date && error.entry_date}
          />
        </div>
      </>
    );
  }
}

export default DescriptionForm;
